import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { LoggerModule } from 'ngx-logger';

@NgModule({
  imports: [LoggerModule.forChild()],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class GseApiModule {}
